<div class="modal-header">
  <h4 class="modal-title d-block">Free Petplan Insurance</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()">
  </button>
</div>

<div class="modal-body">
  <div class="row mt-2">
    <div class="col-12">
      <p>
        Please look through stage 4 to complete registration and unlock your offers.
      </p>
      <p class="float-end">
        <a [routerLink]="[]" (click)="navigateToWelcomeGiftPage()">Get Free Petplan Insurance now!</a>
      </p>
    </div>
  </div>
</div>
